export type ParsedCCTroop = {
  name: string;
  count: number;
  icon: string | null;
};

import { getTroopIcon } from "./troopIcons";

export function parseCCTroops(
  input: string[]
): ParsedCCTroop[] {
  return input.map((raw) => {
    const match = raw.match(/^(\d+)x\s*(.+)$/i);

    const count = match ? Number(match[1]) : 1;
    const name = match ? match[2] : raw;

    return {
      name,
      count,
      icon: getTroopIcon(name),
    };
  });
}
